export default function useWebMerchandisingAccess() {
  return true
}
